/**
 * Renders a styled container that wraps its child elements.
 *
 * @param {Object} props - The properties object.
 * @param {React.ReactNode} props.children - The child elements to be rendered inside the container.
 * @param {string} [props.className] - Additional CSS classes to apply to the container.
 * @param {React.CSSProperties} [props.style] - Inline styles to apply to the container.
 * @returns {JSX.Element} The rendered container element.
 */
export default function Box({
  children,
  className = "",
  style = {},
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`border bg-white border-[#bdbed4] py-[20px] px-[30px] rounded-[5px] mb-[20px] ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
